import { useEffect, useState } from 'react'
import { CircleMarker, MapContainer, TileLayer, useMap } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import BasemapSelector, { BASEMAPS } from './BasemapSelector'
import MapLegend from './MapLegend'
import MarkerCluster from './MarkerCluster'

const WORLD_CENTER = [20, 0]
const WORLD_ZOOM = 2

// Recentre la carte quand un événement est sélectionné depuis la liste.
const FlyToSelection = ({ event }) => {
    const map = useMap()

    useEffect(() => {
        if (!event) return
        map.flyTo([event.lat, event.lng], Math.max(map.getZoom(), 6), { duration: 0.8 })
    }, [map, event])

    return null
}

const FireMap = ({ events, selectedEvent, onSelect }) => {
    const [basemap, setBasemap] = useState('dark')
    const tiles = BASEMAPS[basemap]

    return (
        <div className="map">
            <MapContainer
                center={WORLD_CENTER}
                zoom={WORLD_ZOOM}
                minZoom={2}
                worldCopyJump
                style={{ width: '100%', height: '100%' }}
            >
                <TileLayer key={basemap} attribution={tiles.attribution} url={tiles.url} />

                <MarkerCluster events={events} onSelect={onSelect} />

                {selectedEvent && (
                    <CircleMarker
                        center={[selectedEvent.lat, selectedEvent.lng]}
                        radius={26}
                        pathOptions={{ color: '#f8fafc', weight: 2, fill: false, dashArray: '4 4' }}
                        interactive={false}
                    />
                )}

                <FlyToSelection event={selectedEvent} />
            </MapContainer>

            <BasemapSelector value={basemap} onChange={setBasemap} />
            <MapLegend />
        </div>
    )
}

export default FireMap
